module.exports = __webpack_public_path__ + "static/media/certificado_de_cobertura_seguro_bicicletas_v1.9487a47e.pdf";